import { provideChameleonDesignSystem } from '../provideChameleonDesignSystem';
import { chameleonCircularProgress } from './CircularProgress.definition';
export function registerCustom(prefix, node) {
    return provideChameleonDesignSystem({ prefix, node }).register(chameleonCircularProgress({ prefix }));
}
